import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCookieConsent } from '../context/CookieConsentContext';
export const CookieConsentBanner: React.FC = () => {
  const {
    consentStatus,
    acceptCookies,
    rejectCookies
  } = useCookieConsent();
  if (consentStatus !== 'pending') {
    return null;
  }
  return <AnimatePresence data-id="element-335">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-336">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.9,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="max-w-lg w-full relative" data-id="element-337">
          {/* Glow effect */}
          <div className="absolute -inset-2 bg-gradient-to-r from-green-600/30 via-green-500/20 to-green-600/30 rounded-2xl blur-xl opacity-60 pointer-events-none" data-id="element-338" />

          <div className="relative bg-gray-900/98 backdrop-blur-xl border border-green-500/40 rounded-2xl shadow-2xl shadow-black/50 overflow-hidden" data-id="element-339">
            {/* Green accent line at top */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-340" />

            <div className="p-6 md:p-8" data-id="element-341">
              {/* Cookie icon centered - elegant and professional */}
              <div className="flex justify-center mb-6" data-id="element-342">
                <motion.div initial={{
                scale: 0.8,
                rotate: -10
              }} animate={{
                scale: 1,
                rotate: 0
              }} transition={{
                duration: 0.5,
                ease: 'easeOut'
              }} className="w-20 h-20 bg-gradient-to-br from-amber-900/30 to-amber-700/20 rounded-full flex items-center justify-center border border-amber-600/40 shadow-lg shadow-amber-900/30" data-id="element-343">
                  <span className="text-6xl" style={{
                  filter: 'drop-shadow(0 2px 8px rgba(217, 119, 6, 0.3))'
                }} data-id="element-344">
                    🍪
                  </span>
                </motion.div>
              </div>

              {/* Text Content */}
              <div className="text-center mb-6" data-id="element-345">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-346">
                  Používáme <span className="text-green-500" data-id="element-347">cookies</span>
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-348">
                  Tento web používá cookies pro analýzu návštěvnosti a zlepšení
                  vašeho zážitku. Kliknutím na "Přijmout" souhlasíte s
                  používáním cookies pro marketingové a analytické účely.
                </p>
              </div>

              {/* Buttons stacked on mobile, side by side on desktop */}
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-349">
                <button onClick={rejectCookies} className="flex-1 px-6 py-3 text-sm font-bold text-gray-300 bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-green-500/30 rounded-lg transition-all duration-300" data-id="element-350">
                  Odmítnout
                </button>
                <button onClick={acceptCookies} className="flex-1 px-6 py-3 text-sm font-bold text-black bg-green-500 hover:bg-green-400 rounded-lg transition-all duration-300 shadow-lg shadow-green-500/25 hover:shadow-green-500/40 hover:scale-105" data-id="element-351">
                  Přijmout
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
};